import cn from "classnames";

import {
  paddingClass,
  toYouTubeEmbedUrl,
  widthClass,
} from "./youtubeEmbed.utils";

export function YoutubeEmbed({ block }: { block: YoutubeEmbedBlock }) {
  const embedUrl = toYouTubeEmbedUrl(block.url);
  if (!embedUrl) return null;

  const title = block.title?.trim() || "YouTube video";

  return (
    <section
      data-testid="youtube-embed"
      className={cn(
        "flex w-full justify-center",
        paddingClass(block.padding, block.tabletPadding, block.mobilePadding),
      )}>
      <div className={cn(widthClass(block.width), "mx-auto")}>
        <div className="relative aspect-video w-full overflow-hidden bg-black">
          <iframe
            src={embedUrl}
            title={title}
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
            className="absolute inset-0 h-full w-full border-0"
          />
        </div>
      </div>
    </section>
  );
}

export type YoutubeEmbedBlock = {
  _type: "youtubeEmbed";
  _key: string;
  url?: string | null;
  title?: string | null;
  width?: string | null;
  padding?: string | null;
  tabletPadding?: string | null;
  mobilePadding?: string | null;
};
